import { FaPlus } from "react-icons/fa6";
import { RiDeleteBinLine } from "react-icons/ri";

export const AddRowBtn = ({ onClick, label }) => (
    <button
        type="button"
        onClick={onClick}
        aria-label={`Add ${label}`}
        className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-indigo-200 bg-indigo-50 text-indigo-600 hover:text-white transition-colors hover:border-indigo-300 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-200"
    >
        <FaPlus size={12} />
    </button>
);

export const DeleteBtn = ({ onClick }) => (
    <button
        type="button"
        onClick={onClick}
        aria-label="Delete"
        className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border hover:border-0 text-red hover:bg-red-500 hover:text-white transition-colors  focus:outline-none focus:ring-2 focus:ring-red-200"
    >
        <RiDeleteBinLine size={16} />
    </button>
);